<template>
  <div class="item-boxes--connected">
    <ItemBoxConnected
      v-for="item in items"
      :key="item.id"
      :link-url="item.linkUrl"
      :image-url="item.imageUrl"
      :brand-name="item.brandName"
      :item-name="item.itemName"
      :item-price="item.itemPrice"
      :is-including-tax="item.isIncludingTax"
      :has-multiple-item-skus="item.hasMultipleItemSkus"
      :is-delivery-item="item.isDeliveryItem"
    />
  </div>
</template>
<script>
import ItemBoxConnected from '../../atoms/item_boxes/ItemBoxConnected'
export default {
  components: { ItemBoxConnected },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
